import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { withAuthentication } from '../Session';
import NetworkDetector from '../NetworkDetector/';

import SidebarRoutes from './sidebar';
import Header from './header';
import MobileHeader from './mobile-header';
import AuthRoutes from './auth-routes';

import {
    footerRoutes,
    gmanagerRoutes,
    adminRoutes,
    employeesRoutes,
    distributorsRoutes,
    storecpRoutes,
    storeownersRoutes,
    routeComponents,
    footerNavLinks
} from './routes';

import styles from './index.module.scss';

const App = (props) => {
// Things to do before unloading/closing the tab



    

    let roleRoutes;
    let showsiteStatus='40px!important';
    if(props.siteStatus!=''){
        showsiteStatus='82px!important';
    }
    switch (props.role) {
        case 'GManager':
            roleRoutes = [...footerRoutes, ...gmanagerRoutes];
            break;
        case 'Admin':
            roleRoutes = [...footerRoutes, ...adminRoutes];
            break;
        case 'Employees':
            roleRoutes = [...footerRoutes, ...employeesRoutes];
            break;
        case 'Distributors':
            roleRoutes = [...footerRoutes, ...distributorsRoutes];
            break;
        case 'StoreCP':
            roleRoutes = [...footerRoutes, ...storecpRoutes];
            break;
        case 'StoreOwners':
            roleRoutes = [...footerRoutes, ...storeownersRoutes];
            break;
        default:
            roleRoutes = footerRoutes;
    }

    if (!props.authUser) {
        return <AuthRoutes />;
    }

    return (
        <Router>
            {props.siteStatus!='' &&<marquee style={{color:props.siteStatusColor,fontSize:'24px'}}> {props.siteStatus}</marquee>}
            <div className={styles.wrapper}>
                <div className={styles.navbar}>
                    <SidebarRoutes
                        role={props.role.toLowerCase()}
                        onSignOut={props.firebase.doSignOut}
                    />
                </div>
                <div>
                    <Header
                        name={props.authUser.FullName}
                        roles={props.allrole}
                        role={props.role}
                        onRoleSwitch={props.firebase.switchLoginAsTo}
                        onSignOut={props.firebase.doSignOut}
                    />
                    <MobileHeader
                        role={props.role}
                        roles={props.allrole}
                        onRoleSwitch={props.firebase.switchLoginAsTo}
                        onSignOut={props.firebase.doSignOut}
                        showsiteStatus={showsiteStatus}
                    />
                    <div className={styles.content}>
                        <div className={styles.main}>
                            {roleRoutes.map((route) => routeComponents[route])}
                        </div>
                        <ul className={styles.footer}>
                            {footerRoutes.map((route,index) => (
                                <li key={'footer_'+index}>{footerNavLinks[route]}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </Router>
    );
};

export default NetworkDetector(withAuthentication(App));
